var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('div',{staticClass:"custom-toast-container"},_vm._l((_vm.$store.state.toasts),function(item){return _c('Toast',_vm._b({key:item.id},'Toast',item,false))}),1),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }